import { Box, Stack, Tooltip, Typography } from "@mui/material";
import Translate from "../../utils/Translate";
import TooltipFields from "../TooltipFields";
import { useState } from "react";

const noRevision = "others";

function calculateAvailableQty(stUnits) {
  if (!stUnits) {
    return "??";
  }

  const nonBlockedStUnits = stUnits.filter((st) => !st.blocked);
  const hasUnlimitedQty = nonBlockedStUnits.findIndex((st) => !!st.isUnlimitedQty) !== -1;
  if (hasUnlimitedQty) {
    return "∞";
  }

  return nonBlockedStUnits.reduce((acc, st) => acc + st.qty, 0);
}

function calculateAvailableQtyPerRevisionFields(stUnits) {
  //;
  const groupedStUnitsByRevision = stUnits.reduce((acc, st) => {
    const revision = st.revision ?? noRevision;
    const currentStUnits = acc[revision] ?? [];
    acc[revision] = [...currentStUnits, st];
    return acc;
  }, {});

  let revisionAndQtyEntries = Object.entries(groupedStUnitsByRevision).map(([revision, sts]) => [
    revision,
    calculateAvailableQty(sts),
  ]);
  revisionAndQtyEntries.sort((a, b) => (a[0] === noRevision ? 1 : b[0] === noRevision ? -1 : a[0].localeCompare(b[0])));
  return revisionAndQtyEntries.map(([revision, qty]) => ({
    label: revision === noRevision ? Translate.get("Others") : revision,
    value: qty,
  }));
}

export default function PartChildChip({ childQty, child }) {
  const [availableQty] = useState(calculateAvailableQty(child.stUnits));

  return (
    <Tooltip
      title={
        <TooltipFields
          fields={[
            {
              label: Translate.get("PartNoLabel"),
              value: child.partNo,
            },
            ...(availableQty > 0
              ? [
                  {
                    label: `${Translate.get("StorageInfoLabel")} (${Translate.get(
                      "StUnitRevisionsLabel",
                    ).toLowerCase()})`,
                    isHeader: true,
                  },
                  ...calculateAvailableQtyPerRevisionFields(child.stUnits),
                  {
                    label: Translate.get("TotalSum"),
                    value: availableQty,
                  },
                ]
              : []),
          ]}
          width="200px"
        />
      }
      arrow
    >
      <Stack className="partChildChip" direction="row" spacing={1} alignItems="center">
        <Box>{`${childQty}x`}</Box>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            maxWidth: "250px",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {child.description?.trim() ?? "??"}
        </Typography>
        <Box>{`(${availableQty})`}</Box>
      </Stack>
    </Tooltip>
  );
}
